import { format } from 'date-fns';

type FormatArgs = {
  data: any[];
  filter?: any;
};

const formatDate = (value: any): string => {
  if (!value) return '';
  return format(new Date(value), 'yyyy-MM-dd');
};

const getField = (field: any, field1?: string, field2?: string): any => {
  if (field === undefined || field === null) return undefined;
  if (field1 === undefined) return field;
  if (field[field1] === undefined || field[field1] === null) return undefined;
  if (field2 === undefined) return field[field1];
  if (field[field1][field2] === undefined || field[field1][field2] === null) return undefined;
  return field[field1][field2];
};

const getFieldByYear = (year: number, field: any[], field1?: string) => {
  if (field === undefined || field === null) return undefined;
  if (field1 === undefined) return field;
  if (field && Array.isArray(field)) {
    const value = field.find((a: any) => a.year === year);
    if (value && value[field1]) {
      return value[field1];
    } else {
      return undefined;
    }
  }

  return undefined;
};

const nutritionMeals = [
  { label: 'Breakfast', value: 1 },
  { label: 'Lunch', value: 2 },
  {
    label: 'Dinner or Afternoon meal',
    value: 3,
  },
  { label: 'Snacks between meals', value: 4 },
  { label: 'Bottle feeding', value: 5 },
  { label: 'None', value: 0 },
];

const nutritionFoodProvider = [
  { label: 'ECD Programme', value: 1 },
  { label: 'Parents', value: 2 },
  { label: 'Government', value: 3 },
  { label: 'NGO or NPO', value: 4 },
  { label: 'Other', value: 97 },
];

const getMultiFieldByYear = ({
  year,
  field,
  field1,
  isFieldValuesInNumbers = false,
  valuesArray,
}: {
  year: number;
  field: any[];
  field1?: string;
  isFieldValuesInNumbers?: boolean;
  valuesArray?: { label: string; value: number }[];
}) => {
  if (field === undefined || field === null) return '';
  if (field1 === undefined) return '';
  if (field && Array.isArray(field)) {
    const value = field.find((a: any) => a.year === year);
    if (value && value[field1]) {
      if (isFieldValuesInNumbers) {
        const values = value[field1].split(',');
        const valuesLabelsArray = values.map((a: any) => {
          if (valuesArray) {
            const value = valuesArray.find((b: { label: string; value: number }) => b.value === Number(a));
            return value ? value.label : '';
          } else {
            return '';
          }
        });
        return valuesLabelsArray.join(', ');
      }
      return value[field1];
    } else {
      return '';
    }
  }

  return '';
};

const formatString = (value: any): string => {
  if (value === undefined || value === null) return '';
  return value as string;
};

const formatBoolean = (value: any): string => {
  if (value === false || value === 0 || value === '0') return 'No';
  if (value === true || value === 1 || value === '1') return 'Yes';
  return '';
};

const formatMasterListBoolean = (value: any): string => {
  if (value === false || value === 0 || value === '0' || value === undefined) return 'No';
  if (value === true || value === 1 || value === '1') return 'Yes';
  return '';
};

const formatOutdoorPlayArea = (value: any): string => {
  if (value === '1' || value === 'Yes') return 'Yes';
  if (value === '0' || value === 'No') return 'No';
  return "Don't know";
};

const formatToilet = (value: string[]): string => {
  return value.join(' ');
};

const formatHandwashing = (value: string[]): string => {
  return value.join(' ');
};

const formatEcdEmploymentStimulus = (value: string): string => {
  if (value === '0') return 'Applied for ECD-ESRF';
  if (value === '1') return 'Received ECD-ESRF';
  return value;
};

const formatContactPerson = (contactList: any[]) => {
  const contact = contactList ? contactList.find(x => x.primaryContact === true) : undefined;
  return {
    contactPersonDesignation: formatString(getField(contact, 'designation')),
    contactPersonFullName: `${formatString(getField(contact, 'firstName'))} ${formatString(
      getField(contact, 'lastName')
    )}`,
    contactPersonContactNumber: formatString(getField(contact, 'contactNumber')),
    contactPersonEmail: formatString(getField(contact, 'emailAddress')),
  };
};

const formatAlternativeContactPerson = (contactList: any[]) => {
  const contact = contactList ? contactList.find(x => x.primaryContact === false) : undefined;
  return {
    contactPersonDesignation: formatString(getField(contact, 'designation')),
    contactPersonFullName: `${formatString(getField(contact, 'firstName'))} ${formatString(
      getField(contact, 'lastName')
    )}`,
    contactPersonContactNumber: formatString(getField(contact, 'contactNumber')),
    contactPersonEmail: formatString(getField(contact, 'emailAddress')),
  };
};

const formatRegistrationOffice = (organisations: any[]) => {
  organisations.forEach(o => {
    if (o.institution) {
      return o.institution.name || '';
    }
  });
  return '';
};

const formatUser = (user: any): string => {
  if (user === null || user === undefined) return '';
  return `${user.firstName || ''} ${user.lastName || ''}`;
};

export const formatIntitutionsExportDataMasterList = ({ data }: FormatArgs) => {
  let results: any[] = [];
  const currentYear = new Date().getFullYear();

  data.forEach((edge: any) => {
    const node = edge.node;

    results.push({
      id: node.id,
      timeStamp: format(new Date(node.updatedAt), 'yyyy-MM-dd hh:mm:ss'),
      province: formatString(getField(node.province, 'name')),
      provinceCD: formatString(getField(node.province, 'code')),
      name: formatString(getField(node.name)),
      emisNumber: formatString(getField(node.emisNumber)),
      district: formatString(getField(node.district, 'name')),

      ecdServiceType: formatString(getField(node.ecdServiceType)),
      registrationType: formatString(getField(node.registrationType, 'name')),
      classification: formatString(getField(node.classification)),

      pcrLevel: formatString(getField(node.pcrLevel)),
      registrationStatus: formatString(getField(node.registrationStatus, 'name')),
      certificateNumber: formatString(getField(node.certificateNumber)),
      issueDate: formatDate(getField(node.issueDate)),
      expiryDate: formatDate(getField(node.expiryDate)),
      progLevel: formatString(getField(node.progLevel)),
      progStatus: formatString(getField(node.progStatus, 'name')),
      progCertificateIssueDate: formatDate(getField(node.progCertificateIssueDate)),
      progCertificateExpiryDate: formatDate(getField(node.progCertificateExpiryDate)),
      progCertificateNumber: formatString(getField(node.progCertificateNumber)),
      newOrRenewal: formatString(getField(node.newOrRenewal)),

      ownerBuild: formatString(getField(node.ecdFacilityDetail, 'buildingOwner')),
      ownerLand: formatString(getField(node.ecdFacilityDetail, 'landowner')),
      gisLongitude: formatString(getField(node.gisLongitude)),
      gisLatitude: formatString(getField(node.gisLatitude)),
      districtMunicipality: formatString(getField(node.districtMunicipality, 'name')),
      localMunicipality: formatString(getField(node.localMunicipality, 'localMunicipality')),
      wardID: formatString(getField(node.wardID)),
      addressee: formatString(getField(node.addressee)),
      townshipVillage: formatString(getField(node.townshipVillage)),
      suburb: formatString(getField(node.suburb)),
      townCity: formatString(getField(node.townCity)),
      streetAddress: formatString(getField(node.streetAddress)),
      postalAddress: formatString(getField(node.postalAddress)),
      officeContactNumber: formatString(getField(node.officeContactNumber)),
      feeLevel: formatString(getField(node.feeLevel)),
      [`numberOfChildrenEnrolled_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'numberOfChildrenEnrolled')
      ),
      [`numberOfChildrenEnrolled_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'numberOfChildrenEnrolled')
      ),
      [`numberOfChildrenEnrolled_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'numberOfChildrenEnrolled')
      ),
      [`numberOfStaff_${currentYear}`]: formatString(getFieldByYear(currentYear, node.ecdStaffData, 'numberOfStaff')),
      [`numberOfStaff${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'numberOfStaff')
      ),
      [`numberOfStaff${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'numberOfStaff')
      ),

      [`fundedThroughEquitableShare_${currentYear}`]: formatMasterListBoolean(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'fundedThroughEquitableShare')
      ),
      [`fundedThroughEquitableShare_${currentYear - 1}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'fundedThroughEquitableShare')
      ),
      [`fundedThroughEquitableShare_${currentYear - 2}`]: formatMasterListBoolean(
        getField(currentYear - 2, node.ecdFinanceDetails, 'fundedThroughEquitableShare')
      ),
      [`numberOfChildrenFunded_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'numChildrenSubsidisedES')
      ),
      [`numberOfChildrenFunded_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'numChildrenSubsidisedES')
      ),
      [`numberOfChildrenFunded_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'numChildrenSubsidisedES')
      ),
      [`fundedThroughConditionalGrant_${currentYear}`]: formatMasterListBoolean(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'fundedThroughConditionalGrant')
      ),
      [`fundedThroughConditionalGrant_${currentYear - 1}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'fundedThroughConditionalGrant')
      ),
      [`fundedThroughConditionalGrant_${currentYear - 2}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'fundedThroughConditionalGrant')
      ),
      [`numChildrenSubsidisedCG_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'numChildrenSubsidisedCG')
      ),
      [`numChildrenSubsidisedCG_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'numChildrenSubsidisedCG')
      ),
      [`numChildrenSubsidisedCG_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'numChildrenSubsidisedCG')
      ),
      [`fundedThroughTopUpSubsidy_${currentYear}`]: formatMasterListBoolean(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'fundedThroughTopUpSubsidy')
      ),
      [`fundedThroughTopUpSubsidy_${currentYear - 1}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'fundedThroughTopUpSubsidy')
      ),
      [`fundedThroughTopUpSubsidy_${currentYear - 2}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'fundedThroughTopUpSubsidy')
      ),
      [`numChildrenSubsidisedTU_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'numChildrenSubsidisedTU')
      ),
      [`numChildrenSubsidisedTU_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'numChildrenSubsidisedTU')
      ),
      [`numChildrenSubsidisedTU_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'numChildrenSubsidisedTU')
      ),
      [`receivedMaintenanceGrant_${currentYear}`]: formatMasterListBoolean(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'receivedMaintenanceGrant')
      ),
      [`receivedMaintenanceGrant_${currentYear - 1}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'receivedMaintenanceGrant')
      ),
      [`receivedMaintenanceGrant_${currentYear - 2}`]: formatMasterListBoolean(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'receivedMaintenanceGrant')
      ),
      [`infrastructureGrantBudget${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'infrastructureGrantBudget')
      ),
      [`infrastructureGrantBudget${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'infrastructureGrantBudget')
      ),
      [`infrastructureGrantBudget${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'infrastructureGrantBudget')
      ),
      [`monthlyCGBudgetTotal${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'monthlyCGBudgetTotal')
      ),
      [`monthlyCGBudgetTotal${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'monthlyCGBudgetTotal')
      ),
      [`monthlyCGBudgetTotal${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'monthlyCGBudgetTotal')
      ),
      [`monthlyESBudgetTotal${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'monthlyESBudgetTotal')
      ),
      [`monthlyESBudgetTotal${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'monthlyESBudgetTotal')
      ),
      [`monthlyESBudgetTotal${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'monthlyESBudgetTotal')
      ),
      [`registeredCapacity${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'registeredCapacity')
      ),
      [`registeredCapacity${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'registeredCapacity')
      ),
      [`registeredCapacity${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'registeredCapacity')
      ),
    });
  });

  return results;
};

export const formatIntitutionsExportData = ({ data }: FormatArgs) => {
  let results: any[] = [];

  const currentYear = new Date().getFullYear();

  data.forEach((edge: any) => {
    const node = edge.node;

    results.push({
      id: node.id,
      name: formatString(getField(node.name)),
      emisNumber: formatString(getField(node.emisNumber)),
      district: formatString(getField(node.district, 'name')),
      ecdServiceType: formatString(getField(node.ecdServiceType)),
      registrationType: formatString(getField(node.registrationType, 'name')),
      pcrLevel: formatString(getField(node.pcrLevel)),
      registrationStatus: formatString(getField(node.registrationStatus, 'name')),
      certificateNumber: formatString(getField(node.certificateNumber)),
      issueDate: formatDate(getField(node.issueDate)),
      expiryDate: formatDate(getField(node.expiryDate)),
      progLevel: formatString(getField(node.progLevel)),
      progStatus: formatString(getField(node.progStatus, 'name')),
      progCertificateIssueDate: formatDate(getField(node.progCertificateIssueDate)),
      progCertificateExpiryDate: formatDate(getField(node.progCertificateExpiryDate)),
      progCertificateNumber: formatString(getField(node.progCertificateNumber)),
      newOrRenewal: formatString(getField(node.newOrRenewal)),

      organisationName: formatString(getField(node.organisationName)),
      networkName: formatString(getField(node.networkName)),
      privateOrNpo: formatString(getField(node.privateOrNpo)),
      registrationNumber: formatString(getField(node.registrationNumber)),
      npoNumber: formatString(getField(node.npoNumber)),
      building: formatString(getField(node.ecdFacilityDetail, 'building')),
      shared: formatString(getField(node.ecdFacilityDetail, 'sharedBuilding')),
      classrooms: formatString(getField(node.ecdFacilityDetail, 'numberOfClassrooms')),
      kitchen: formatString(getField(node.ecdFacilityDetail, 'kitchen')),
      space: formatString(getField(node.censusDataLatest, 'kitchen')),
      outdoor: formatOutdoorPlayArea(formatString(getField(node.ecdFacilityDetail, 'outdoorPlayArea'))),
      toilet:
        node.ecdFacilityDetail && node.ecdFacilityDetail.typesOfToilets
          ? formatToilet(node.ecdFacilityDetail.typesOfToilets)
          : '',
      toilets_children: formatBoolean(getField(node.ecdFacilityDetail, 'separateToilets')),
      toilets_gender: formatString(getField(node.censusDataLatest, 'toilets_gender')),
      capture_toilets_total: formatString(getField(node.ecdFacilityDetail, 'numToilets')),
      count_toilets_children: formatString(getField(node.ecdFacilityDetail, 'childrenToilets')),
      count_toilets_adults: formatString(getField(node.ecdFacilityDetail, 'adultToilets')),
      heating: formatString(getField(node.ecdFacilityDetail, 'mainSourceOfPowerHeating')),
      lighting: formatString(getField(node.ecdFacilityDetail, 'mainSourceOfPowerLighting')),
      cooking: formatString(getField(node.ecdFacilityDetail, 'mainSourceOfPowerCooking')),
      water: formatString(getField(node.ecdFacilityDetail, 'mainSourceOfWater')),
      waterother: formatString(getField(node.ecdFacilityDetail, 'mainSourceOfWaterOther')),
      potable: formatString(getField(node.censusDataLatest, 'potable')),
      handwashing:
        node.ecdFacilityDetail && node.ecdFacilityDetail.whatHandwashingFacility
          ? formatHandwashing(node.ecdFacilityDetail.whatHandwashingFacility)
          : '',
      [`meals_${currentYear}`]: getMultiFieldByYear({
        year: currentYear,
        field: node.nutrition,
        field1: 'mealsProvided',
        isFieldValuesInNumbers: true,
        valuesArray: nutritionMeals,
      }),
      [`meals_${currentYear - 1}`]: getMultiFieldByYear({
        year: currentYear - 1,
        field: node.nutrition,
        field1: 'mealsProvided',
        isFieldValuesInNumbers: true,
        valuesArray: nutritionMeals,
      }),
      [`meals_${currentYear - 2}`]: getMultiFieldByYear({
        year: currentYear - 2,
        field: node.nutrition,
        field1: 'mealsProvided',
        isFieldValuesInNumbers: true,
        valuesArray: nutritionMeals,
      }),

      [`foodProvider_${currentYear}`]: getMultiFieldByYear({
        year: currentYear,
        field: node.nutrition,
        field1: 'foodProvider',
        isFieldValuesInNumbers: true,
        valuesArray: nutritionFoodProvider,
      }),
      [`foodProvider_${currentYear - 1}`]: getMultiFieldByYear({
        year: currentYear - 1,
        field: node.nutrition,
        field1: 'foodProvider',
        isFieldValuesInNumbers: true,
        valuesArray: nutritionFoodProvider,
      }),
      [`foodProvider_${currentYear - 2}`]: getMultiFieldByYear({
        year: currentYear - 2,
        field: node.nutrition,
        field1: 'foodProvider',
        isFieldValuesInNumbers: true,
        valuesArray: nutritionFoodProvider,
      }),

      [`foodProviderOther_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.nutrition, 'foodProviderOther')
      ),
      [`foodProviderOther_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.nutrition, 'foodProviderOther')
      ),
      [`foodProviderOther_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.nutrition, 'foodProviderOther')
      ),

      [`monthlyFeeRangeLowest_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'monthlyFeeRangeLowest')
      ),
      [`monthlyFeeRangeLowest_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'monthlyFeeRangeLowest')
      ),
      [`monthlyFeeRangeLowest_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'monthlyFeeRangeLowest')
      ),
      [`monthlyFeeRangeHighest_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'monthlyFeeRangeHighest')
      ),
      [`monthlyFeeRangeHighest_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'monthlyFeeRangeHighest')
      ),
      [`monthlyFeeRangeHighest_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'monthlyFeeRangeHighest')
      ),
      [`numberOfStaff_${currentYear}`]: formatString(getFieldByYear(currentYear, node.ecdStaffData, 'numberOfStaff')),
      [`numberOfStaff_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'numberOfStaff')
      ),
      [`numberOfStaff_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'numberOfStaff')
      ),
      [`count_staff_male_${currentYear}`]: formatString(getFieldByYear(currentYear, node.ecdStaffData, 'male')),
      [`count_staff_male_${currentYear - 1}`]: formatString(getFieldByYear(currentYear - 1, node.ecdStaffData, 'male')),
      [`count_staff_male_${currentYear - 2}`]: formatString(getFieldByYear(currentYear - 2, node.ecdStaffData, 'male')),

      [`count_staff_female_${currentYear}`]: formatString(getFieldByYear(currentYear, node.ecdStaffData, 'female')),
      [`count_staff_female_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'female')
      ),
      [`count_staff_female_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'female')
      ),

      [`count_staff_salary_paid_${currentYear}`]: formatString(getFieldByYear(currentYear, node.ecdStaffData, 'paid')),
      [`count_staff_salary_paid_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'paid')
      ),
      [`count_staff_salary_paid_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'paid')
      ),

      [`count_staff_salary_unpaid_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'unpad')
      ),
      [`count_staff_salary_unpaid_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'unpad')
      ),
      [`count_staff_salary_unpaid_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'unpad')
      ),
      count_staff_other: formatString(getField(node.censusDataLatest, 'count_staff_gender_other')),
      count_staff_contract_permanent: formatString(getField(node.censusDataLatest, 'count_staff_contract_permanent')),
      count_staff_contract_temporary: formatString(getField(node.censusDataLatest, 'count_staff_contract_temporary')),
      count_staff_contract_substitute: formatString(getField(node.censusDataLatest, 'count_staff_contract_substitute')),

      [`count_staff_time_full_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'fullTime')
      ),
      [`count_staff_time_full_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'fullTime')
      ),
      [`count_staff_time_full_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'fullTime')
      ),
      [`count_staff_time_part_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'partTime')
      ),
      [`count_staff_time_part_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'partTime')
      ),
      [`count_staff_time_part_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'partTime')
      ),
      [`count_staff_cat_educator_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'gradeREducators')
      ),
      [`count_staff_cat_educator_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'gradeREducators')
      ),
      [`count_staff_cat_educator_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'gradeREducators')
      ),
      [`count_staff_cat_practitioner_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'ecdPractitioners')
      ),
      [`count_staff_cat_practitioner_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'ecdPractitioners')
      ),
      [`count_staff_cat_practitioner_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'ecdPractitioners')
      ),
      [`count_staff_cat_manager_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'managerialStaff')
      ),
      [`count_staff_cat_manager_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'managerialStaff')
      ),
      [`count_staff_cat_manager_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'managerialStaff')
      ),
      [`count_staff_cat_support_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'supportStuff')
      ),
      [`count_staff_cat_support_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'supportStuff')
      ),
      [`count_staff_cat_support_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'supportStuff')
      ),
      [`count_staff_qual_skills_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'accreditedECDSkillsProgram')
      ),
      [`count_staff_qual_skills_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'accreditedECDSkillsProgram')
      ),
      [`count_staff_qual_skills_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'accreditedECDSkillsProgram')
      ),

      [`count_staff_qual_nqf4_5_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'nqfLevel4to5ECD')
      ),
      [`count_staff_qual_nqf4_5_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'nqfLevel4to5ECD')
      ),
      [`count_staff_qual_nqf4_5_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'nqfLevel4to5ECD')
      ),

      [`count_staff_qual_nqf6_9_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdStaffData, 'nqfLevel6to9ECD')
      ),
      [`count_staff_qual_nqf6_9_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdStaffData, 'nqfLevel6to9ECD')
      ),
      [`count_staff_qual_nqf6_9_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdStaffData, 'nqfLevel6to9ECD')
      ),

      [`numberOfChildrenEnrolled_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'numberOfChildrenEnrolled')
      ),
      [`numberOfChildrenEnrolled_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'numberOfChildrenEnrolled')
      ),
      [`numberOfChildrenEnrolled_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'numberOfChildrenEnrolled')
      ),

      [`ageRange0To12Months_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange0To12Months')
      ),
      [`ageRange0To12Months_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange0To12Months')
      ),
      [`ageRange0To12Months_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange0To12Months')
      ),

      [`ageRange0To18Months_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange0To18Months')
      ),
      [`ageRange0To18Months_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange0To18Months')
      ),
      [`ageRange0To18Months_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange0To18Months')
      ),

      [`ageRange18MonthsTo3Years_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange0To18Months')
      ),
      [`ageRange18MonthsTo3Years_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange0To18Months')
      ),
      [`ageRange18MonthsTo3Years_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange18MonthsTo3Years')
      ),

      [`ageRange1To2Years_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange1To2Years')
      ),
      [`ageRange1To2Years_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange1To2Years')
      ),
      [`ageRange1To2Years_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange1To2Years')
      ),

      [`ageRange2To3Years_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange2To3Years')
      ),
      [`ageRange2To3Years_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange2To3Years')
      ),
      [`ageRange2To3Years_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange2To3Years')
      ),

      [`ageRange3To4Years_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange3To4Years')
      ),
      [`ageRange3To4Years_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange3To4Years')
      ),
      [`ageRange3To4Years_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange3To4Years')
      ),

      [`ageRange4To5Years_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange4To5Years')
      ),
      [`ageRange4To5Years_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange4To5Years')
      ),
      [`ageRange4To5Years_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange4To5Years')
      ),

      [`ageRange5To6Years_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'ageRange5To6Years')
      ),
      [`ageRange5To6Years_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'ageRange5To6Years')
      ),
      [`ageRange5To6Years_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'ageRange5To6Years')
      ),

      [`gradeROffered_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'gradeROffered')
      ),
      [`gradeROffered_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'gradeROffered')
      ),
      [`gradeROffered_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'gradeROffered')
      ),

      [`funding_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'mainFundingSource')
      ),
      [`funding_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'mainFundingSource')
      ),
      [`funding_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'mainFundingSource')
      ),

      [`subsidy_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'receivesDBESubsidy')
      ),
      [`subsidy_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'receivesDBESubsidy')
      ),
      [`subsidy_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'receivesDBESubsidy')
      ),

      [`fundedThroughEquitableShare_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'fundedThroughEquitableShare')
      ),
      [`fundedThroughEquitableShare_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'fundedThroughEquitableShare')
      ),
      [`fundedThroughEquitableShare_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'fundedThroughEquitableShare')
      ),

      [`fundedThroughConditionalGrant_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'fundedThroughConditionalGrant')
      ),
      [`fundedThroughConditionalGrant_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'fundedThroughConditionalGrant')
      ),
      [`fundedThroughConditionalGrant_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'fundedThroughConditionalGrant')
      ),
      [`fundedThroughTopUpSubsidy_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'fundedThroughTopUpSubsidy')
      ),
      [`fundedThroughTopUpSubsidy_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'fundedThroughTopUpSubsidy')
      ),
      [`fundedThroughTopUpSubsidy_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'fundedThroughTopUpSubsidy')
      ),

      [`assessedForMaintenanceGrant_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'assessedForMaintenanceGrant')
      ),
      [`assessedForMaintenanceGrant_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'assessedForMaintenanceGrant')
      ),
      [`assessedForMaintenanceGrant_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'assessedForMaintenanceGrant')
      ),

      [`receivedMaintenanceGrant_${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'receivedMaintenanceGrant')
      ),
      [`receivedMaintenanceGrant_${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'receivedMaintenanceGrant')
      ),
      [`receivedMaintenanceGrant_${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'receivedMaintenanceGrant')
      ),
      [`infrastructureGrantBudget${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'infrastructureGrantBudget')
      ),
      [`infrastructureGrantBudget${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'infrastructureGrantBudget')
      ),
      [`infrastructureGrantBudget${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'infrastructureGrantBudget')
      ),
      [`monthlyCGBudgetTotal${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'monthlyCGBudgetTotal')
      ),
      [`monthlyCGBudgetTotal${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'monthlyCGBudgetTotal')
      ),
      [`monthlyCGBudgetTotal${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'monthlyCGBudgetTotal')
      ),
      [`monthlyESBudgetTotal${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdFinanceDetails, 'monthlyESBudgetTotal')
      ),
      [`monthlyESBudgetTotal${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdFinanceDetails, 'monthlyESBudgetTotal')
      ),
      [`monthlyESBudgetTotal${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdFinanceDetails, 'monthlyESBudgetTotal')
      ),
      [`registeredCapacity${currentYear}`]: formatString(
        getFieldByYear(currentYear, node.ecdEnrolmentData, 'registeredCapacity')
      ),
      [`registeredCapacity${currentYear - 1}`]: formatString(
        getFieldByYear(currentYear - 1, node.ecdEnrolmentData, 'registeredCapacity')
      ),
      [`registeredCapacity${currentYear - 2}`]: formatString(
        getFieldByYear(currentYear - 2, node.ecdEnrolmentData, 'registeredCapacity')
      ),

      professionals_practitioners: formatString(getField(node.censusDataLatest, 'professionals_practitioners')),
      numberOfChildrenFunded: formatString(getField(node.numberOfChildrenFunded)),
      fundingother: formatString(getField(node.censusDataLatest, 'fundingother')),
      confirm_subsidy: '',
      yearOfReceipt: formatString(getField(node.yearOfReceipt)),
      ecdEmploymentStimulus: formatEcdEmploymentStimulus(formatString(getField(node.receivedEcdEsrf))),
      dateECDESRFReceived: formatDate(getField(node.dateECDESRFReceived)),
      country: formatString(getField(node.country, 'name')),
      province: formatString(getField(node.province, 'name')),
      districtMunicipality: formatString(getField(node.districtMunicipality, 'name')),
      localMunicipality: formatString(getField(node.localMunicipality, 'localMunicipality')),
      wardID: formatString(getField(node.wardID)),
      streetAddress: formatString(getField(node.streetAddress)),
      suburb: formatString(getField(node.suburb)),
      townshipVillage: formatString(getField(node.townshipVillage)),
      townCity: formatString(getField(node.townCity)),
      locality: formatString(getField(node.locality)),
      postalAddress: formatString(getField(node.postalAddress)),
      postalCode: formatString(getField(node.postalCode)),
      gisAltitude: formatString(getField(node.gisAltitude)),
      gisLatitude: formatString(getField(node.gisLatitude)),
      gisLongitude: formatString(getField(node.gisLongitude)),
      gisSource: formatString(getField(node.gisSource)),
      nearestPointOfInterest: formatString(getField(node.nearestPointOfInterest)),
      pointOfInterest: formatString(getField(node.pointOfInterest)),
      officeEmailAddress: formatString(getField(node.officeEmailAddress)),
      officeContactNumber: formatString(getField(node.officeContactNumber)),
      ...formatContactPerson(getField(node.organisation, 'contactList')),
      ...formatAlternativeContactPerson(getField(node.organisation, 'contactList')),
      registrationOffice: formatRegistrationOffice(node.registrationOffice),
      identifiedBy: formatString(getField(node.ecdRegistrationLatest, 'identifiedBy')),
      dateIdentified: formatDate(getField(node.ecdRegistrationLatest, 'dateIdentified')),
      sspSupervisor: formatUser(node.sspSupervisor),
      socialServicesProfessional: formatUser(node.socialServicesProfessional),
      duplicateReference: formatString(getField(node.duplicateReference)),
      duplicateAction: formatString(getField(node.duplicateAction)),
      reasonForDuplicateAction: formatString(getField(node.reasonForDuplicateAction)),
      trackingCode: formatString(getField(node.trackingCode)),
      verified: formatString(getField(node.verified)),
      validated: formatString(getField(node.validated)),
      source: formatString(getField(node.dataSource)),
      censusDate: formatString(getField(node.censusDataLatest, 'year')),
      isArchived: formatBoolean(getField(node.isArchived)),
      timeStamp: format(new Date(node.updatedAt), 'yyyy-MM-dd hh:mm:ss'),
    });
  });

  return results;
};
